export default __webpack_public_path__ + "media/images/arrow-down-461b26afb78e771f63376a216bb36c00.svg";